/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { API } from 'middleware/api';

export const SET_STATUS = 'SET_STATUS';

/**
 * Action that defines the status of payment method.
 *
 * @param {string} status - The status of the payment method.
 *
 * @return {Object}
 */
export const setPaymentMethodStatus = status => ({
  type: SET_STATUS,
  payload: { status },
});

export const REGISTER_FREELANCE_REQUEST = 'REGISTER_FREELANCE_REQUEST';
export const REGISTER_FREELANCE_SUCCESS = 'REGISTER_FREELANCE_SUCCESS';
export const REGISTER_FREELANCE_FAILURE = 'REGISTER_FREELANCE_FAILURE';

/**
 * Create action object that is used to register a company.
 *
 * @param {string} token - JWT for request authentification.
 * @param {Object} freelance - The freelance object.
 *
 * @NOTE: ADD PARAMS HERE WHEN WE KNOW.
 *
 * @return {Object}
 */
export const registerFreelance = (token, freelance) => ({
  [API]: {
    endpoint: '/user/freelance/register',
    method: 'POST',
    body: freelance,
    token,
    types: [
      REGISTER_FREELANCE_REQUEST,
      REGISTER_FREELANCE_SUCCESS,
      REGISTER_FREELANCE_FAILURE,
    ],
  },
});

export const REGISTER_FREELANCE_COMPANY_REQUEST =
  'REGISTER_FREELANCE_COMPANY_REQUEST';
export const REGISTER_FREELANCE_COMPANY_SUCCESS =
  'REGISTER_FREELANCE_COMPANY_SUCCESS';
export const REGISTER_FREELANCE_COMPANY_FAILURE =
  'REGISTER_FREELANCE_COMPANY_FAILURE';

/**
 * Create action object that is used to register a company.
 *
 * @param {string} token - JWT for request authentification.
 * @param {Object} company - The company object.
 * @param {string} company.vat - The company’’s VAT ID.
 *
 * @return {Object}
 */
export const registerCompany = (token, company) => ({
  [API]: {
    endpoint: '/user/company/register',
    method: 'POST',
    body: company,
    token,
    types: [
      REGISTER_FREELANCE_COMPANY_REQUEST,
      REGISTER_FREELANCE_COMPANY_SUCCESS,
      REGISTER_FREELANCE_COMPANY_FAILURE,
    ],
  },
});

export const UPDATE_FREELANCE_COMPANY_REQUEST =
  'UPDATE_FREELANCE_COMPANY_REQUEST';
export const UPDATE_FREELANCE_COMPANY_SUCCESS =
  'UPDATE_FREELANCE_COMPANY_SUCCESS';
export const UPDATE_FREELANCE_COMPANY_FAILURE =
  'UPDATE_FREELANCE_COMPANY_FAILURE';

/**
 * Create action object that is used to update the details of a company.
 *
 * @param {string} token - JWT for request authentification.
 * @param {Object} company - The company object.
 * @param {string} company.name - Name of the company.
 * @param {string} company.invoice_email - Email of the company.
 * @param {string} company.website_url - Url of the company’s website.
 * @param {string} company.picture_cloudinary_public_id - Public ID of the company picture uploaded to Cloudinary..
 * @param {string} company.street1 - The street adress of the company.
 * @param {string} company.street2 - The street adress of the company.
 * @param {string} company.zip - The zip code of the company.
 * @param {string} company.city - The company’s city.
 * @param {string} company.country - The company’s tax country.
 *
 * @return {Object}
 */
export const updateCompany = (token, company) => ({
  [API]: {
    endpoint: '/user/company/update',
    method: 'POST',
    body: company,
    token,
    types: [
      UPDATE_FREELANCE_COMPANY_REQUEST,
      UPDATE_FREELANCE_COMPANY_SUCCESS,
      UPDATE_FREELANCE_COMPANY_FAILURE,
    ],
  },
});
